const publicPage = require('./publicPages/routes');
const catalogPage = require('./publicPages/catalogRoutes');

// All startup choices follow the same destination decision. Fragments stay router-owned.
module.exports = function destination(path, errorPage = false) {
  const settings = /^\/settings(?:\/|$)/i.test(path);
  const admin = /^\/admin\/?$/i.test(path);
  const page = publicPage(path) || catalogPage(path);
  let routes = settings ? 'settings' : admin ? 'admin' : 'dashboard';
  if (/^\/brew\/\d+\/[^/]+\/(readings\/edit|visitors)\/?$/i.test(path)) routes = 'brew_tools';
  else if (/^\/share\/\d+(?:\/|$)/i.test(path)) routes = 'shared_brew';
  else if (/^\/brew\/\d+(?:\/|$)/i.test(path)) routes = /\/edit\/?$/i.test(path) ? 'brew_editor' : 'owner_brew';

  let root = 'application';
  if (errorPage) root = 'error';
  else if (page) root = 'public';
  else if (/^\/(account\/resetpwd(?:\/[^/]+)?|external-login\/create)\/?$/i.test(path)) root = 'recovery';
  else if (/^\/(login|register|accountconfirmed)\/?$/i.test(path)) root = 'authentication';

  return {
    root, page: root === 'public' ? page : null, store: admin ? 'admin' : 'dashboard', routes,
    mode: settings ? 'history' : 'hash', base: settings ? '/settings' : '/',
    session: root === 'public' ? 'optional' : root === 'application' && routes !== 'shared_brew' ? 'required' : 'none'
  };
};
